import React from "react";
import style from "./Row.module.scss";

export const Row = ({ label, value }) =>
  value === null || value === undefined || value === "" || (Array.isArray(value) && !value.length) ? null : (
    <p className={style.form_view_row}>
      <label>{label}:</label>
      <span>{Array.isArray(value) ? value.join(", ") : value}</span>
    </p>
  );
